import LogoutIcon from '@mui/icons-material/Logout'
import MenuIcon from '@mui/icons-material/Menu'
import { Box, Breadcrumbs, IconButton, Link, styled } from '@mui/material'
import { MButton, Text } from 'components'
import { CLIENT, ROUTES_PATH, TOPBAR_ITEMS, WEB_TOPBAR_ITEMS } from 'config'
import { color } from 'config/color'
import { useAuth, useSidebar } from 'context'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { screenType, useWindowSize } from 'utils'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'


export const TopBar: React.FC = () => {
  const { width } = useWindowSize()
  const location = useLocation()
  const navigate = useNavigate()
  const { openSidebar, setOpenSidebar } = useSidebar()
  const { handleLogOut } = useAuth()
  const [page, setPage] = useState<any>({})
  const isMobile = useMobileBreakpoints()
  const clientName = process.env.REACT_APP_CLIENT_NAME

  useEffect(() => {
    const topBarItems = clientName === CLIENT.WEB ? WEB_TOPBAR_ITEMS : TOPBAR_ITEMS
    const pageData = topBarItems.find(
      (item) => item.href === location.pathname
    )
    setPage(pageData)
  }, [clientName, location.pathname])


  const handleLogout = async (): Promise<void> => {
    await handleLogOut()
  }

  const Logo = process.env.REACT_APP_CLIENT_LOGO


  return (
    <>
      {isMobile
        ? (
          <Box
            p={2}
            pt={3}
            bgcolor={color.white}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box height={50} component="img" src={Logo} alt="background" />
            <IconButton
              onClick={() => {
                setOpenSidebar(!openSidebar)
              }}
            >
              <MenuIcon fontSize="large" sx={{ color: color.primary[700] }} />
            </IconButton>
          </Box>
        )
        : (
          <Wrapper>
            <BarInner>
              <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={5}
                borderBottom={`solid 1px ${color.secondary.dark[300]}`}
              >
                <Box>
                  <Text
                    color={color.black}
                    fontWeight="600"
                    fontSize={screenType(width, 'sm') ? '20px' : '32px'}
                    margin="0 0 2px"
                  >
                    {page?.title}
                  </Text>
                  <Breadcrumbs>
                    <Link
                      underline="hover"
                      onClick={() => {
                        navigate(ROUTES_PATH.DASHBOARD)
                      }}
                    >
                      <Text
                        color={color.secondary.dark[700]}
                        fontSize={screenType(width, 'sm') ? '10px' : '12px'}
                      >
                        Admin
                      </Text>
                    </Link>
                    <Text
                      color={color.grey[700]}
                      fontSize={screenType(width, 'sm') ? '10px' : '12px'}
                    >
                      {page?.title}
                    </Text>
                  </Breadcrumbs>
                </Box>
                <MButton
                  variant="text"
                  texttransform="none"
                  endIcon={<LogoutIcon />}
                  onClick={handleLogout}
                >
                  Log out
                </MButton>
              </Box>
            </BarInner>
          </Wrapper>
        )}
    </>
  )
}

const Wrapper = styled(Box)`
  margin-left: auto;
  width: calc(100vw - 240px);
  margin-left: 240px;
  background-color: ${color.secondary.dark[50]};
  position: fixed;
  z-index: 999;
`

const BarInner = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`
